'use client';

import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { uiService } from '@/services/ui.service';
import { KafkaNote } from '@nf/utils-common/constants';
import clsx from 'clsx';
import { sidebarToggleButtonStyle } from './sidebar-toggle-button.style';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';

export const SidebarToggleButton = () => {
	const view = useAppearanceStore(state => state.view);

	const openSidebar = () => {
		const kafkaData = {
			note: KafkaNote.GalaxyV2,
			type: 1,
			action: 1
		}
		setKafkaNormal(kafkaData);

		uiService.controlSidebar(true);	
	};

	return (
		<div 
			className="header__menu"
			onClick={openSidebar}
		>
			<div className={clsx('header__menu-line', { [sidebarToggleButtonStyle.headerMenuLine]: view === ViewEnum.mars })}></div>
			<div className={clsx('header__menu-line', { [sidebarToggleButtonStyle.headerMenuLine]: view === ViewEnum.mars })}></div>
			<div className={clsx('header__menu-line', { [sidebarToggleButtonStyle.headerMenuLine]: view === ViewEnum.mars })}></div>
		</div>
	);
};